// Gestione centralizzata del consenso ai cookie / servizi di terze parti.
// Fonte di verità unica letta sia dal CookieBanner sia dalla facade di Google Maps.

export const CONSENT_COOKIE_NAME = "mangimi-rubini-cookie-consent";
export const CONSENT_PREFERENCES_KEY = "mangimi-rubini-cookie-preferences";
export const CONSENT_UPDATED_EVENT = "cookie-consent-updated";

export interface CookiePreferences {
  necessary: true;
  // 'maps' governa il caricamento dell'embed Google Maps (terza parte).
  maps: boolean;
}

export const DEFAULT_PREFERENCES: CookiePreferences = {
  necessary: true,
  maps: false,
};

/**
 * Legge le preferenze granulari salvate in localStorage.
 * Ritorna null se l'utente non ha ancora espresso alcuna scelta.
 */
export function getStoredPreferences(): CookiePreferences | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_PREFERENCES_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<CookiePreferences>;
    return {
      necessary: true,
      maps: Boolean(parsed.maps),
    };
  } catch {
    return null;
  }
}

/** Salva le preferenze granulari e notifica i componenti in ascolto. */
export function savePreferences(preferences: CookiePreferences): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      CONSENT_PREFERENCES_KEY,
      JSON.stringify(preferences)
    );
  } catch {
    /* localStorage non disponibile: ignora, il cookie di consenso resta la prova minima */
  }
  window.dispatchEvent(
    new CustomEvent<CookiePreferences>(CONSENT_UPDATED_EVENT, {
      detail: preferences,
    })
  );
}

/** Cancella le preferenze salvate (usato dalla revoca dal footer). */
export function clearPreferences(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(CONSENT_PREFERENCES_KEY);
  } catch {
    /* ignora */
  }
  window.dispatchEvent(
    new CustomEvent<CookiePreferences>(CONSENT_UPDATED_EVENT, {
      detail: DEFAULT_PREFERENCES,
    })
  );
}

export function hasMapsConsent(): boolean {
  return getStoredPreferences()?.maps ?? false;
}
